var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function LightningIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.79186 2.70244C6.88427 2.29177 7.24898 2 7.66991 2H16.6552C17.3098 2 17.7454 2.67654 17.4745 3.27243L15.6157 7.36176L20.1596 6.9831C20.9614 6.91628 21.4413 7.85482 20.9177 8.4657L8.47567 22.9814C7.85369 23.7071 6.67875 23.0909 6.92198 22.1667L9.1663 13.6382L5.46147 14.0087C4.85051 14.0698 4.35909 13.5146 4.49387 12.9156L6.79186 2.70244ZM8.54991 4L6.77984 11.8669L10.7587 11.469C11.2792 11.417 11.6917 11.9003 11.5586 12.4062L10.0756 18.0417L17.6552 9.19873L13.6582 9.53182C13.0875 9.57938 12.6762 8.99546 12.9132 8.47405L14.9469 4H8.54991Z", fill: "" })));
}
export var LightningIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: LightningIconInner }, props))); };
//# sourceMappingURL=LightningIcon.js.map